// extracted by mini-css-extract-plugin
export default {"menu":"AddPopup_menu__7GLCa"};